// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class TimeInterval {
    constructor(startHours, startMins, endHours, endMins) {
        this.startHours = startHours !== null && startHours !== void 0 ? startHours : 0;
        this.startMins = startMins !== null && startMins !== void 0 ? startMins : 0;
        this.endHours = endHours === 0 ? 0 : (endHours !== null && endHours !== void 0 ? endHours : 23);
        this.endMins = endMins === 0 ? 0 : (endMins !== null && endMins !== void 0 ? endMins : 59);
    }
    tryUpdate(newTimeInterval) {
        let isUpdated = false;
        if (this.startHours !== newTimeInterval.startHours) {
            this.startHours = newTimeInterval.startHours;
            isUpdated = true;
        }
        if (this.startMins !== newTimeInterval.startMins) {
            this.startMins = newTimeInterval.startMins;
            isUpdated = true;
        }
        if (this.endHours !== newTimeInterval.endHours) {
            this.endHours = newTimeInterval.endHours;
            isUpdated = true;
        }
        if (this.endMins !== newTimeInterval.endMins) {
            this.endMins = newTimeInterval.endMins;
            isUpdated = true;
        }
        return isUpdated;
    }
    getStartInMins() {
        return this.getMinutes(this.startHours, this.startMins);
    }
    getEndInMins() {
        return this.getMinutes(this.endHours, this.endMins);
    }
    getMinutes(hours, mins) {
        return hours * 60 + mins;
    }
}
